import applicationEventHub from "../events/applicationEventHub";

function getRandomNumber(min,max){
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default {
  achievement : (number=null)=>{
     if(number===null){
       //number=getRandomNumber(1,5)
       number=1;
     }
    applicationEventHub.playFrameworkSound('achievement'+number);
  },
  success : (number=null)=>{
    if(number===null){
      number=1;//getRandomNumber(1,3)
    }
    applicationEventHub.playFrameworkSound('success'+number);
  },
  achievementWithApplause(number=null){
    if(number===null){
      number=getRandomNumber(1,5);
      applicationEventHub.playFrameworkSound('achievement'+number+'_applause');
    }
  },
  successWithApplause(number=null){
    if(number===null){
      number=getRandomNumber(1,3);
      applicationEventHub.playFrameworkSound('success'+number+'_applause');
    }
  },
  applause(){
    applicationEventHub.playFrameworkSound('applause');
  },
  clink(){
    applicationEventHub.playFrameworkSound('recording_countdown');
  },
  beep(){
    applicationEventHub.playFrameworkSound('recording_get_ready');
  },
  beep2(){
    applicationEventHub.playFrameworkSound('recording_time_almost_reached');
  },
  alert(){
    applicationEventHub.playFrameworkSound('recording_started');
  },
  warning(){
    applicationEventHub.playFrameworkSound('recording_finally_stopped');
  },
  warning2(){
    applicationEventHub.playFrameworkSound('recording_time_reached');
  },
  criticalError(){
    applicationEventHub.playFrameworkSound('recording_stopped_error');
  },
  picture(){
    applicationEventHub.playFrameworkSound('recording_get_ready');
  }
}